import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as Logger from 'js-logger';
import cx from 'classnames';
import {
  isMobile, isIOS, isIOS13
} from "react-device-detect";
import { setTextHeight } from "../../store/actions";

import * as Actions from '../../store/actions';
import * as PlayActions from '../../store/actions/play-actions';
import * as ReadActions from '../../store/actions/read-actions';
import {
  toggleControlsHover,
  toggleControlsVisibility,
} from "../../store/actions/controls-visibility-actions";
import ImageFrame from '../../components/ImageFrame';
import { getOrientation } from '../../tools/utils';

import PaginatedTextContainer from '../../components/PaginatedTextContainer';
import ResizeIcon from '../../components/svg-icons/ResizeIcon';
import ReadProgress from '../../components/ReadProgress';


import {
  getTotalNumberOfFrames,
  getAvailableNumberOfFrames,
  getTextOfTheCurrentFrame,
  getIsBookWithText,
  getIsSlideZoomed,
  getGalleryVisibility,
  getControlsVisibility,
  getViewMode,
  getEncriptedImages,
  getIsControlsOnHover,
  getBookId,
  getCurrentTextAreaPage,
  getBookCover,
  getCurrentTheme,
  getIsDemo,
  getIsFree,
  getIsFullscreen,
  getIsWidget,
  getActiveFrame,
  getImageSlides, getParentSelector,
} from '../../store/selectors/selectors'

import "./style.scss";

function regexMobileCheck () {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

const isMobileOrIOS = isMobile || isIOS || isIOS13 || regexMobileCheck();

class TextPlayer extends Component {

  static defaultProps = {
    isBookWithText: true,
  }

  constructor(props) {
    super(props);
    this.readingContainer = React.createRef();
    this.resizeHandler = React.createRef();
    this.resizeHandlerIcon = React.createRef();
    this.resizeTrack = React.createRef();
    this.state = {
      isSlideZoomed: false,
      tooltipEnabled: false,
      dragClicked: false,
      isHovered: false,
    };
    this.logger = Logger.get('TextPlayer');
  }

  componentDidMount() {
    this.onReady();
  }

  zoomReadArea = () => {
    if (!isMobileOrIOS) {
      this.props.toggleZoomSlide();
    }
  }

  onZoomAreaTouch = () => {
    if (isMobileOrIOS) {
      this.props.toggleControlsVisibility();
    }
  };

  onReady = () => {
    if (!this.props.isWitget) {
      window.parent.postMessage("web-viewer-ready-text", "*");
    }
    if (isMobileOrIOS && getOrientation() === "portrait") {
      this.props.setTextHeight(this.readingContainer.current.offsetHeight/2);
    }
    const self = this;
    if ('onorientationchange' in window && isMobileOrIOS) {
      window.addEventListener("orientationchange", function() {
        if(getOrientation() === "portrait"){
          self.props.setTextHeight(self.readingContainer.current.offsetWidth/2);
        } else self.props.setTextHeight(130);
      }, false);
    }
  };

  prevFrame = () => {
    this.props.setPreviosFrame()
  };

  nextFrame = () => {
    this.props.setNextFrame()
  };

  // clickableZoneWidth
  // 0.5 = half of width
  // 0.25 = quarter of width
  // 0.3 = third of width
  onNavigationPanelClick = (event, clickableZoneWidth = .5) => {
    event.stopPropagation();
    let posX = event.touches ? event.touches[0].pageX : event.pageX;
    const bodyWidth = this.readingContainer.current.offsetWidth
    const clickableZoneSize = bodyWidth * clickableZoneWidth;

    if (posX < clickableZoneSize) {
      this.props.prevPage();
    }

    if (posX > (bodyWidth - clickableZoneSize)) {
      this.props.nextPage();
    }
  };

  resizeMouseDown = (e) => {
    if (e.target === this.resizeHandler.current && !this.props.isSlideZoomed && this.props.isBookWithText) {
      let x = e.pageX;
      if (e.touches) {
        x = e.touches[0].pageX;
      }
      const mainWindowSize = document.querySelector(this.props.parentSelector).parentElement.getBoundingClientRect();
      x = x - mainWindowSize.right + mainWindowSize.width;
      const resizeHandlerIcon = this.resizeHandlerIcon.current;
      resizeHandlerIcon.style.left = x + 'px';
      this.setState({
        dragClicked: true,
      });
    }
  };

  resizeMouseUp = () => {
    this.setState({ dragClicked: false });
  };

  resizeMouseMove = (e) => {
    let yPos = e.clientY;
    let x = e.clientX;
    if (e.touches) {
      yPos = e.touches[0].clientY;
      x = e.touches[0].clientX;
    }
    const mainWindowSize = document.querySelector(this.props.parentSelector).parentElement.getBoundingClientRect();
    x = x - mainWindowSize.right + mainWindowSize.width;

    if(this.resizeHandlerIcon.current) {
      this.resizeHandlerIcon.current.style.left = this.state.isHovered ? x + 'px' : '50%';
    }
    // if(this.resizeHandlerIcon.current) {
    //   let coordinates = this.resizeHandler.current.getBoundingClientRect()
    //   if (yPos < (coordinates.top- this.resizeHandlerIcon.current.offsetHeight) && yPos > (coordinates.top - coordinates.height - this.resizeHandlerIcon.current.offsetHeight) &&
    //       x > coordinates.left && x < (coordinates.left + coordinates.width)
    //   ) {
    //     this.resizeHandlerIcon.current.style.position = 'fixed';
    //     this.resizeHandlerIcon.current.style.left = x + 'px';
    //     this.resizeHandlerIcon.current.style.top = (yPos) + 'px';
    //   }
    //
    // }

    if (this.state.dragClicked === true) {
      let containerHeight = this.readingContainer.current.offsetHeight;
      let textBoxHeight = containerHeight - yPos + mainWindowSize.top;

      if (textBoxHeight < 130) {
        textBoxHeight = 130;
      }

      if (textBoxHeight > containerHeight / 2) {
        textBoxHeight = containerHeight / 2;
      }

      this.props.setTextHeight(textBoxHeight);
    }
  };

  handleMouseEnter = () => {
    if (isMobileOrIOS) {
      this.setState({ tooltipEnabled: true });
    }
  }

  handleMouseLeave = () => {
    if (isMobileOrIOS) {
      this.setState({ tooltipEnabled: false });
    }
  }

  setIsHovered = () =>{
    this.setState({ isHovered: true });
  }

  unsetIsHovered = () =>{
    this.setState({ isHovered: false });
  }

  render() {
    const {
      visible,
      images,
      textOfTheCurrentFrame,
      currentTheme,
      isFullscreen,
      galleryVisibility,
      totalNumberOfFrames,
      availableNumberOfFrames,
      isWidget,
      isDemo,
      encriptedImages,
      isBookWithText,
      isSlideZoomed,
      currentTextAreaPage,
      controlsVisibility
    } = this.props;

    let { activeFrame } = this.props;

    const { tooltipEnabled } = this.state;

    let activeFrameImage = encriptedImages[activeFrame];

    if(getOrientation() === 'portrait' && activeFrame === 0) {
      activeFrameImage = this.props.posterUrl;
    }

    if (activeFrame > 0 && !images[activeFrame]) {
      activeFrame = isDemo ? availableNumberOfFrames : totalNumberOfFrames;
    }

    return (
      <div
        className={cx(
          'reading-container ',
          currentTheme,
          {
            hidden: !visible,
            'is-blurred': galleryVisibility
          }
        )}
        ref={this.readingContainer}
        /*onClick={(e) => this.onClick(e)}*/
        onMouseMove={this.resizeMouseMove}
        onTouchMove={this.resizeMouseMove}
        onMouseDown={this.resizeMouseDown}
        onMouseUp={this.resizeMouseUp}
        onTouchStart={this.resizeMouseDown}
        onTouchEnd={this.resizeMouseUp}
        onMouseLeave={this.resizeMouseUp}
      >

        {isMobileOrIOS && !isFullscreen && isWidget &&
          <div
            className="cnb-on-toggle-isFullscreen"
            onClick={this.props.onClickFullscreen}
          />
        }


        <div
          className="canvas-container"
          onClick={event => this.onNavigationPanelClick(event, .3)}
        // onMouseMove={this.onMouseMove}
        >


          {activeFrameImage &&
            <ImageFrame
              image={activeFrameImage}
            />
          }

          {activeFrame > 0 &&
            <div
              className={cx('canvas-hover-aria', { 'zoom': isSlideZoomed }, { 'no-text': !isBookWithText })}
              onClick={this.zoomReadArea}
              onTouchEnd={this.onZoomAreaTouch}
            />
          }
          <div className="canvas-container__next-frame" />
          <div className="canvas-container__prev-frame" />
          <div
            className={cx('read-progress', {
              'read-progress--is-hidden': !controlsVisibility || activeFrame == 0 || isSlideZoomed
            })}
            onMouseEnter={this.handleMouseEnter}
            onMouseLeave={this.handleMouseLeave}
          >
            <ReadProgress
              max={totalNumberOfFrames}
              activeFrame={activeFrame}
              availableNumberOfFrames={this.props.availableNumberOfFrames}
              setFrameToView={this.props.setFrameToView}
              tooltipVisibility={tooltipEnabled}
            />
          </div>
        </div>
        <div
          onMouseEnter={this.setIsHovered}
          onMouseLeave={this.unsetIsHovered}
        >
        { controlsVisibility &&
          <div
              className={
                cx(
                    'resize-track',
                    {
                      'resize-track--hidden': activeFrame == 0 || isSlideZoomed || !isBookWithText
                    }
                )
              }
              ref={this.resizeTrack}
          >
            <div
                ref={this.resizeHandler}
                className={activeFrame !== 0 ? 'resize-handler' : ''}
                style={{dispaly: activeFrame !== 0 ? 'none' : 'block'}}
            />

            <div
                ref={this.resizeHandlerIcon}
                className="resize-icon"
            >
              <ResizeIcon/>
            </div>
          </div>
        }
        {isBookWithText &&

          <div
            className={cx('reading-block-container', {
              'reading-block-container--is-hidden': isSlideZoomed || activeFrame <= 0
            })}
          >
            <div
              className="cnb-text-player__text"
              onClick={this.onNavigationPanelClick}
            >
              <PaginatedTextContainer
                text={textOfTheCurrentFrame}
                onBeginReached={this.prevFrame}
                onEndReached={this.nextFrame}
                // onRecalculate={(data) => this.logger.log('recalculated', data)}
                changeTextAreaPage={this.props.changeTextAreaPage}
                page={currentTextAreaPage - 1}
                isFullscreen={isFullscreen}
                activeFrame={activeFrame}
              />
            </div>
          </div>
        }
        </div>
      </div>
    );
  }



}

const mapStateToProps = state => {
  const controlsVisibility = getControlsVisibility(state)

  return {
    activeFrame: getActiveFrame(state) === -1 ? 0 : getActiveFrame(state),
    isWidget: getIsWidget(state),
    parentSelector: getParentSelector(state),
    galleryVisibility: getGalleryVisibility(state),
    isControlsOnHover: getIsControlsOnHover(state),
    controlsVisibility,
    visible: getViewMode(state) === 'text',
    textOfTheCurrentFrame: getTextOfTheCurrentFrame(state),
    images: getImageSlides(state),
    encriptedImages: getEncriptedImages(state),
    bookId: getBookId(state),
    currentTheme: getCurrentTheme(state),
    isSlideZoomed: getIsSlideZoomed(state),
    availableNumberOfFrames: getAvailableNumberOfFrames(state),
    totalNumberOfFrames: getTotalNumberOfFrames(state),
    isFree: getIsFree(state),
    isDemo: getIsDemo(state),
    posterUrl: getBookCover(state),
    isBookWithText: getIsBookWithText(state),
    isFullscreen: getIsFullscreen(state),
    currentTextAreaPage: getCurrentTextAreaPage(state),
  };
};

const actionCreators = {
  ...Actions,
  ...PlayActions,
  ...ReadActions,
  toggleControlsHover,
  toggleControlsVisibility,
  setTextHeight
}

export default connect(mapStateToProps, actionCreators)(TextPlayer)


// WEBPACK FOOTER //
// ./src/containers/text-player/TextPlayer.jsx